import React from "react";
import { Button } from "@vitalsource/vstui";
import { connect } from "react-redux";

import { Translation } from "../../../../core/translate";
import { selectors as brandSelectors } from "../../../../../redux/brand";
import { safeRedirect } from "../../../../utils/location";
import CleverIcon from "./clever-icon";

const Clever = ({ cleverEnabled, launchClever, cleverURL }) => {
  if (cleverEnabled) {
    return (
      <div>
        <Button
          type="submit"
          iconStart={<CleverIcon />}
          size="large"
          href={cleverURL}
          onClick={launchClever}
        >
          <Translation id="signin.clever">Sign In with Clever</Translation>
        </Button>
      </div>
    );
  }
  return null;
};

const mapStateToProps = state => {
  const cleverURL = brandSelectors.getBrandValue(state, "Clever.url", false);
  return {
    cleverEnabled: brandSelectors.getBrandValue(state, "Clever.enabled", false),
    cleverURL,
    launchClever: e => {
      e.preventDefault();
      // Redirect to clever URL, which should talk to BC and redirect back
      safeRedirect(cleverURL, "_self");
    }
  };
};

export default connect(mapStateToProps)(Clever);
